module.exports = __webpack_public_path__ + "img/color-filter-outline-blue.786a5c85.svg";